import React, {useState} from 'react';
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import {Box, Button, DialogActions, DialogContent, DialogTitle, Tooltip} from "@mui/material";
import {COLORS} from "../../../../../../Constants";
import FormControl from "@mui/material/FormControl";
import {gluing} from "../../../../../../data/Gluing";
import {useNavigate} from "react-router-dom";
import {EditLocalStoragePagesData} from "../../../../../../utils/EditLocalStoragePagesData";
import ButtonExit from "../../../../../../components/UI/button/ButtonExit";
import ButtonAdd from "../../../../../../components/UI/button/ButtonAdd";

const EdgeModal = ({
                       type,
                       edgesData,
                       detailData,
                       onClose,
                       onSubmit,
                       editableElementId,
                       openConfirmModal,
                       redirectEdges
                   }) => {
    const currEdgeId = type === "addEdge"
        ? edgesData[0]?.id
        : detailData.edges?.find((el) => el?.id === editableElementId)?.orderEdge?.id
    const [selectedValue, setSelectedValue] = useState(currEdgeId);
    return (
        <>
            <DialogTitle
                textAlign="center"> {edgesData.length === 0 ? "В заказе нет кромок" : type === "addEdge" ? "Добавить кромку" : "Изменить кромку"} </DialogTitle>
            <DialogContent style={{paddingBottom: 0}}>
                <FormControl component="fieldset">
                    <RadioGroup
                        aria-label="edge"
                        name="radio-buttons-group"
                    >
                        {edgesData.map((el, i) => (
                            <FormControlLabel
                                sx={{
                                    height: "30px",
                                    borderBottom: (theme) => `${theme.palette.primary.stroke} solid 1px`, margin: 0,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.light
                                    }
                                }}
                                key={i} checked={selectedValue === el.id}
                                control={<Radio onChange={() => setSelectedValue(el.id)} sx={{
                                    padding: 0,
                                    '& .MuiSvgIcon-root': {
                                        fontSize: 15,
                                    },
                                }}/>}
                                label={<Box style={{display: "flex", alignItems: "center",}}>
                                    <Box style={{
                                        width: "13px",
                                        height: "13px",
                                        borderRadius: "4px",
                                        margin: "5px",
                                        backgroundColor: COLORS[el.color][400],

                                    }}/>

                                    <Tooltip arrow placement="top"  title={el.materialArticleNumber}>
                                       <span style={{
                                           fontSize: "14px",
                                           width: "130px",
                                           textOverflow: "ellipsis",
                                           whiteSpace: "nowrap",
                                           overflow: "hidden"
                                       }}>
                                           {el.materialArticleNumber}
                                       </span>
                                    </Tooltip>
                                    <Tooltip arrow placement="top" title={el.materialName}>
                                    <span style={{
                                        fontSize: "14px", width: "580px", textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden"
                                    }}>{el.materialName}</span>
                                    </Tooltip>
                                    <span style={{fontSize: "14px", width: "70px"}}>{gluing[el.edgeType]}</span>
                                </Box>}>
                            </FormControlLabel>
                        ))}
                    </RadioGroup>
                    <Box style={{display: "flex", justifyContent: "flex-end", paddingTop: 20}}>
                        {type === "editEdge" && <Button
                            size="small"
                            color="secondary"
                            onClick={() => openConfirmModal("deleteEdge", editableElementId)}
                            variant="outlined"
                        >
                            Удалить кромку
                        </Button>}
                    </Box>
                </FormControl>
            </DialogContent>
            <DialogActions sx={{p: '1.25rem'}}>
                <ButtonExit text={"Отменить"} onClick={onClose}/>
                <ButtonAdd width={edgesData.length === 0 ? 200 : 117}
                           text={edgesData.length === 0 ? "К добавлению кромок" : "Выбрать"}
                           onClick={() => edgesData.length === 0 ? redirectEdges() : onSubmit(selectedValue)}/>
            </DialogActions>
        </>
    )
}
export default EdgeModal
